import type { ROUTE_CALLS } from './routes'

import { Navigation404Error } from '~/router/errors'

import { verifyFeatureAvailability } from '~/features-generic/config-manager/composables/feature-manager'

import type { NavigationGuard } from '~/typings/vue-router'

export const navigationGuardCalls: NavigationGuard<ROUTE_CALLS> = (to, from, next) => {
  return Promise.resolve()
    .then(async () => {
      return verifyFeatureAvailability('calls')
        .then((result) => {
          if (!result)
            throw new Navigation404Error('This page does not exist')
        })
    })
    .then(() => next())
    .catch(error => next(error))
}
